<template>
	<div>
		<div style="height: 16px;">
			{{mainValue ? mainValue : subValue}}
		</div>
		<div v-if="mainValue && subValue" class="grid-cell-sub-line">
			{{subValue}}
		</div>
	</div>
</template>

<script>
export default {
	name: 'DetailsCell',
	props: {
		mainValue: [String, Number],
		subValue: [String, Number]
	},
};
</script>